const Report = () =>
  import(
    /* webpackChunkName: "log-exception" */ '@/pages/log/exception/index.vue'
  )

const Detail = () =>
  import(
    /* webpackChunkName: "log-exception" */ '@/pages/log/exception/detail.vue'
  )

export default {
  path: 'exception',
  meta: { label: 'exception' },
  component: {
    name: 'ExceptionLog',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'LogExceptionReport',
      path: '',
      meta: { label: 'report' },
      component: Report
    },
    {
      name: 'LogDetailException',
      path: 'detail/:id',
      meta: { label: 'detail' },
      component: Detail,
      props: true
    }
  ]
}
